import {Pipe, PipeTransform} from '@angular/core';
import {Config} from 'compob2b-table';
import {FiltersService} from '../../../../compob2b-table/lib/services/filters.service';

@Pipe({
  name: 'sort',
  standalone: true
})
export class SortPipe implements PipeTransform {
  private defaultArray: any[] = [];

  private static isNaN(aV: any, bV: any): boolean {
    return isNaN(parseFloat(aV)) || !isFinite(aV) || isNaN(parseFloat(bV)) || !isFinite(bV);
  }

  private static compare(a: any[], b: any[], key: string): number {
    const split = key.split('.');
    const aPath = FiltersService.getPath(split, a);
    const bPath = FiltersService.getPath(split, b);
    let aValue = (aPath + '').toLowerCase();
    let bValue = (bPath + '').toLowerCase();
    if (SortPipe.isNaN(aPath, bPath)) {
      aValue = this.naturalSortTranslit(aValue);
      bValue = this.naturalSortTranslit(bValue);
      return aValue.localeCompare(bValue, 'ru', {numeric: true});
    }
    if (parseFloat(aPath) < parseFloat(bPath)) {
      return -1;
    }
    if (parseFloat(aPath) > parseFloat(bPath)) {
      return 1;
    }

    return 0;
  }

  transform(array: any[], filter: { order: string; key: string }, config?: Config): any[] {
    if (!array) {
      array = [];
    }
    if (this.defaultArray.length === 0) {
      this.defaultArray = array;
    }
    if (!filter.key || filter.key === '') {
      return array;
    }
    if (filter.order === '') {
      return this.defaultArray;
    }
    if (filter.order === 'asc') {
      return this.sortAsc(array, filter, config);
    }
    return this.sortDesc(array, filter, config);
  }

  private sortAsc(array: any[], filter: { order: string; key: string }, config?: Config): any[] {
    if (config && config.groupRows) {
      return array.map((arr) => arr.sort((a, b) => SortPipe.compare(a, b, filter.key)));
    }
    return array.sort((a, b) => SortPipe.compare(a, b, filter.key));
  }

  private sortDesc(array: any[], filter: { order: string; key: string }, config?: Config): any[] {
    if (config && config.groupRows) {
      return array.map((arr) => arr.sort((a, b) => SortPipe.compare(b, a, filter.key)));
    }
    return array.sort((a, b) => SortPipe.compare(b, a, filter.key));
  }

  static naturalSortTranslit(word: string) {
    let answer = word.toLowerCase();
    answer = answer.replace(/[^-0-9a-zа-яё]/g, '-');
    answer = answer.replace(/[-]+/g, '-');
    answer = answer.replace(/^-|-$/g, '');
    return answer;
  }

  static naturalSort(arr: any[], field: string): any[] {
    return arr.sort((a, b) => {
      a = this.naturalSortTranslit(a[field]);
      b = this.naturalSortTranslit(b[field]);
      return a.localeCompare(b, 'ru', {numeric: true});
    });
  }

}
